// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBox_wrapper__KiQ+4","richTextEditor":"InfoBox_richTextEditor__NQLhm"};